import ActivityTeamEducation from './activityTeamEducation.js';
export default ActivityTeamEducation;
